<template>
  <v-sheet color="grey lighten-4 width-100 height-100 pa-4" rounded>
    <div class="d-flex flex-column">
      <div class="d-flex align-center mb-2">
        <h3 class="text-subtitle-1 font-weight-medium mb-0 mr-3">Preview</h3>
        <v-btn small @click="loadCode" :loading="loading">Reload</v-btn>
      </div>
      <div ref="canvasHost" class="preview-host"></div>
      <v-alert v-if="error" type="error" dense text class="mt-2">{{ error }}</v-alert>
    </div>
  </v-sheet>
</template>

<script>
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/firebase/init';

export default {
  name: 'GamePreview',
  props: { game: { type: Object, required: true } },
  data() { return { loading: false, error: '', disposer: null }; },
  mounted() { this.loadCode(); },
  beforeDestroy() { if (this.disposer) this.disposer(); },
  methods: {
    async loadCode() {
      this.loading = true; this.error = '';
      try {
        const gameRef = doc(db, 'games', this.game.id);
        const gameSnap = await getDoc(gameRef);
        let code = '';
        const current = gameSnap.data()?.currentCodeVersionId;
        if (current) {
          const verRef = doc(db, 'games', this.game.id, 'codeVersions', current);
          const verSnap = await getDoc(verRef);
          code = verSnap.exists() ? (verSnap.data().code || '') : '';
        }
        this.runSketch(code);
      } catch (e) { this.error = e.message; }
      finally { this.loading = false; }
    },
    runSketch(code) {
      if (this.disposer) { this.disposer(); this.disposer = null; }
      this.$refs.canvasHost.innerHTML = '';
      const container = document.createElement('div');
      this.$refs.canvasHost.appendChild(container);
      try {
        const fn = new Function('p5', 'container', `with (container) { ${code} }`);
        // Attach p5 to window already present from main.js
        fn(window.p5, container);
      } catch (e) {
        this.error = `Runtime error: ${e.message}`;
      }
      // basic disposer to clear host
      this.disposer = () => { this.$refs.canvasHost.innerHTML = ''; };
    }
  }
};
</script>

<style scoped>
.preview-host { min-height: 400px; border: 1px dashed #bbb; background: #fff; }
</style>
